import React from 'react';
import './CoachingReviewScorecardDetails.styl';
import CircularProgress from 'components/pure/utils/CircularProgress';
import isNil from 'lodash/isNil';
import {RichText} from 'components/pure/utils/form/user-taggable-input/RichTextEditor';
import {getMuiV4Theme} from 'utils/css/themeUtils';

const TO_PERCENT = 100;
export default class CoachingReviewGenericDetails extends React.PureComponent {
  render() {
    const {contentDetailScore, caller} = this.props;
    const percentage = (contentDetailScore.score * TO_PERCENT) / 5;
    const callerName = caller ? caller.firstName : 'the caller';
    const skillName = contentDetailScore.contentDetail.skillName;
    const question =
      contentDetailScore.contentDetail.custom ||
      `How would you rate ${callerName} on ${skillName} in this call?`;

    return (
      <div className="coaching-review-generic-details">
        <div className="score call-question">
          <div className="label">{question}</div>
          <div className="value rating">
            {isNil(contentDetailScore.score) ? (
              <div className="no-score">
                <span className="na-text">N/A</span>
              </div>
            ) : (
              <div className="score-ring">
                <CircularProgress
                  color={getMuiV4Theme().palette.primary.main}
                  percentage={percentage}
                />
                <span className="ring-label">{percentage}%</span>
              </div>
            )}
          </div>
        </div>
        {contentDetailScore.comment && (
          <div className="comment call-question">
            <div className="label">Comment:</div>
            <RichText className="value" dangerousText={contentDetailScore.comment} />
          </div>
        )}
      </div>
    );
  }
}
